




















































































import { computed, defineComponent, nextTick } from '@vue/composition-api';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import { IS_PC } from '@/common/constant';
import '@/renderer/assets/images/Icon/svg/clientDownload/android.svg';
import '@/renderer/assets/images/Icon/svg/clientDownload/apple.svg';
import '@/renderer/assets/images/Icon/svg/clientDownload/window.svg';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import getRequest from '@/renderer/scripts/httpRequest';
import tips from '@/renderer/scripts/utils/tips';
import { i18n_t } from '@/locales/i18n';
import { httpUrl } from '@/renderer/scripts/http';
import { transformErrorForSerialization } from '@/common/tools';
const QRCode = require('qrcode');

export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseIcon,
  },
  name: 'PrivateClientDownloadDialog',
  setup(props, context) {
    const isPc = IS_PC;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const drawQRCode = (canvasId: string, url: string) => {
      const canvas = document.getElementById(canvasId);
      QRCode.toCanvas(
        canvas,
        url,
        {
          width: 184,
          height: 184,
          margin: 3,
        },
        (error: any) => {
          if (error) logger.ui.error('移动端下载二维码绘制失败', transformErrorForSerialization(error));
        },
      );
    };

    const ymlFileCache = new Map<string, string>();
    const mobileUrlCache = new Map<string, string>();

    const getDesktopClientDownLoadUrl = async (channel: string, prefix: string): Promise<string> => {
      try {
        let ymlFile = '';
        if (ymlFileCache.has(channel)) {
          ymlFile = ymlFileCache.get(channel) ?? '';
        } else {
          const request = getRequest({ logPrefix: 'clientDownload' });
          const url = `${httpUrl.webUrl}/releases/${channel}.yml`;
          const res = await request({
            url,
            method: 'get',
          });
          const { data } = res;
          ymlFile = data;
          ymlFileCache.set(channel, ymlFile);
        }

        const YAML = require('yamljs');
        const { files } = YAML.parse(ymlFile);
        if (files && files.length > 0) {
          for (let i = 0; i < files.length; ++i) {
            if (files[i].url.indexOf(prefix) !== -1) {
              return `${httpUrl.webUrl}/releases/${files[i].url}`;
            }
          }
        }
      } catch (err) {}
      return '';
    };

    const getMobileClientDownLoadUrl = async (channel: string): Promise<string> => {
      try {
        if (mobileUrlCache.has(channel)) {
          return mobileUrlCache.get(channel) ?? '';
        }
        const request = getRequest({ logPrefix: 'clientDownload' });
        const url = `${httpUrl.webUrl}/releases/${channel}/upgrade.json`;
        const res = await request({
          url,
          method: 'get',
        });
        const { data } = res;
        const jsonData = data;

        if ('fullUrl' in jsonData) {
          mobileUrlCache.set(channel, jsonData.fullUrl);
          return jsonData.fullUrl;
        }
        let prefix = '';
        let relativePath = '';
        if ('prefix' in jsonData) {
          prefix = jsonData.prefix;
        }
        if ('relativeUrl' in jsonData) {
          relativePath = jsonData.relativeUrl;
        }
        const downUrl = `${prefix}${httpUrl.webUrl}/${relativePath}`;
        mobileUrlCache.set(channel, downUrl);
        return downUrl;
      } catch (err) {}
      return '';
    };

    const downloadWindowClient = () => {
      getDesktopClientDownLoadUrl('latest', 'TCE-Drive-win32').then(url => {
        if (url) {
          dispatchRouter(url);
        } else {
          tips.error(i18n_t('获取下载链接失败'));
        }
      });
    };

    const downloadMacClient = (chip: string) => {
      const prefix = chip === 'apple' ? '.arm64.dmg' : '.x64.dmg';
      getDesktopClientDownLoadUrl('latest-mac', prefix).then(url => {
        if (url) {
          dispatchRouter(url);
        } else {
          tips.error(i18n_t('获取下载链接失败'));
        }
      });
    };

    const onCloseDialog = () => {
      innerShow.value = false;
      ymlFileCache.clear();
      mobileUrlCache.clear();
    };

    const onIOSPopupVisibleChange = (visible: boolean) => {
      if (visible) {
        nextTick(async () => {
          const ret = encodeURIComponent(await getMobileClientDownLoadUrl('iOS'));
          const qrcUrl = `${httpUrl.webUrl}/tools/mobileClientDownload/mobileClientDownload.html?installerUrl=${ret}`;
          drawQRCode('ios_qrc_canvas', qrcUrl);
        });
      }
    };

    const onAndroidPopupVisibleChange = (visible: boolean) => {
      if (visible) {
        nextTick(async () => {
          const ret = encodeURIComponent(await getMobileClientDownLoadUrl('Android'));
          const qrcUrl = `${httpUrl.webUrl}/tools/mobileClientDownload/mobileClientDownload.html?installerUrl=${ret}`;
          drawQRCode('android_qrc_canvas', qrcUrl);
        });
      }
    };

    return {
      innerShow,
      onCloseDialog,
      isPc,
      downloadWindowClient,
      downloadMacClient,
      onIOSPopupVisibleChange,
      onAndroidPopupVisibleChange,
    };
  },
});
